import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import s from './BackButton.module.css'

function BackButton({ fallback = null, className = '' }) {
  const router = useRouter()

  const handleClick = () => {
    router.back()
    // todo: ideally we could use the 'fallback' prop to navigate to if we don't
    // have a 'back' state (i.e. new tab directly to URL)
  }

  return (
    <button
      type="button"
      className={classNames(s.container, className)}
      onClick={handleClick}
    >
      <div className={s.btn} />
    </button>
  )
}

BackButton.propTypes = {
  className: PropTypes.string,
  fallback: PropTypes.string,
}

export default BackButton
